export default {
  bounds: state => state.bounds,
  map: state => state.map,
  markers: state => state.list
};
